import { take, fork } from 'redux-saga/effects';
import { APPLICATION_DATA_ERROR, APPLICATION_DATA_REQUESTING, APPLICATION_DATA_SUCCESS } from './constants';
import { requestData } from '../flows/request-data';
import gql from 'graphql-tag';
import { getAppData } from '../../graphql/queries';

export default function * applicationWatcher(): any {
  while(true) {
    const {
      type,
      onComplete
    } = yield take([
      APPLICATION_DATA_REQUESTING,
    ]);

    switch (type) {
      case APPLICATION_DATA_REQUESTING: {
        yield fork(requestData(gql(getAppData), APPLICATION_DATA_SUCCESS, APPLICATION_DATA_ERROR), {lang: 'fi'}, onComplete);
      }
    }
  }
}


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/application/sagas.ts